<template>
    <div>
        <router-view v-show="$route.matched.length == 3"></router-view>
        <PageHeaderLayout v-show="$route.matched.length == 2">
            <div class="main-page-content">
                <el-row class="table-header" v-if="userPermissions.indexOf('tradeWithdraw_create') != -1">
                    <el-col>
                        <el-tooltip effect="dark" content="创建配置" placement="top-start" v-if="userPermissions.indexOf('tradeWithdraw_create') != -1 && buttonType == 'icon'">
                            <el-button type="primary" size="medium" icon="iconfont icon-tianjiacaidan2" @click="addButton(0)"></el-button>
                        </el-tooltip>
                        <el-button
                            type="primary"
                            size="medium"
                            icon="iconfont"
                            v-if="userPermissions.indexOf('tradeWithdraw_create') != -1 && buttonType == 'text'"
                            @click="addButton(0)"
                        >
                            创建配置
                        </el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
                        <el-form-item label="订单号"><el-input v-model="searchCondition.outer_trade_no" placeholder="输入订单号" clearable></el-input></el-form-item>
                        <el-form-item label="姓名"><el-input v-model="searchCondition.bank_account_name" placeholder="输入姓名" clearable></el-input></el-form-item>
                        <el-form-item label="身份证"><el-input v-model="searchCondition.id_number" placeholder="输入身份证号" clearable></el-input></el-form-item>
                        <el-form-item label="时间"><DatePicker ref="dataSearch" @dataSearch="dataSearch" /></el-form-item>
                        <!-- <el-form-item label="ID">
              <el-input v-model="searchCondition.id" placeholder="输入ID" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证">
              <el-input v-model="searchCondition.remark" placeholder="输入身份证号" clearable></el-input>
            </el-form-item> -->
                        <el-form-item><el-button type="primary" @click="searchButton">查询</el-button>
                       <el-button style="margin-left: 20px;" :loading="dianzi_downloadLoading" type="primary" @click="dowloadDZHD">导出电子回单</el-button>
                        </el-form-item>
                        <!-- <div class="table-right">
              <el-form-item>
                <el-select v-model="value" @change="selectData" class="select-box">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :loading="downloadLoading" type="primary" icon="el-icon-document" @click="handleDownload">
                  导出
                </el-button>
              </el-form-item>
            </div> -->
                    </el-form>
                </el-row>
                <el-row class="second-row" v-if="userPermissions.indexOf('exportReceipt') != -1 && is_yichen">
                    <ScreeCompany :allowField="allowField" @ScreeCompany="ScreeCompany" />
                    <div class="table-right">
                        <MonthPicker ref="MonthSearch" @MonthSearch="MonthSearch" />
                        <el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <el-button :loading="downloadLoading" style="margin: 0 0 20px 20px" type="primary" size="medium" icon="el-icon-document" @click="handleBeforeDownload">
                            导出
                        </el-button>
                    </div>
                </el-row>
                <ApeTable
                    ref="apeTable"
                    style="font-size: 12px"
                    :data="tradeWithdrawList"
                    :columns="columns"
                    :loading="loadingStaus"
                    :pagingData="pagingData"
                    @switchPaging="switchPaging"
                    highlight-current-row
                >
                    <!-- <el-table-column
            v-if="buttonType=='text'"
            width="160"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('tradeWithdraw_view') != -1"  @click="viewButton(scope.row.id)">详情</el-button>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('tradeWithdraw_edit') != -1"  @click="editButton(scope.row.id)">编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('tradeWithdraw_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini">删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column> -->
					<el-table-column slot="first-column" align="center" label="ID">
					<template slot-scope="scope">
					<div type="text">{{ scope.row.id }}</div>
					</template>
					</el-table-column>
                    <el-table-column slot="first-column" align="center" label="公司名称">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.outer_trade_no" placement="top">
                                <div type="text">{{ scope.row.company_name }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column slot="first-column" align="center" prop="bank_account_name" sortable label="姓名">
                        <template slot-scope="scope">
                            {{ scope.row.bank_account_name }}
                        </template>
                    </el-table-column>
                    <el-table-column slot="second-column" prop="money" align="center" sortable :label="isLaowuCompany?'实发金额':'金额'">
                        <template slot-scope="scope">
                            <div class="tag-group">
                                <el-tag type="success">¥ {{ isLaowuCompany?scope.row.after_tax_money:scope.row.money }}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
										<el-table-column slot="second-column" v-if="!isLaowuCompany" prop="money" align="center" label="实发金额">
												<template slot-scope="scope">
													{{ scope.row.real_money || 0 }}
												</template>
										</el-table-column>
										<el-table-column v-if="!isLaowuCompany" slot="second-column" prop="money" align="center" label="个税">
												<template slot-scope="scope">
													{{ scope.row.now_tax_money || 0 }}
                        </template>
                    </el-table-column>
					<el-table-column  slot="second-column" prop="added_tax_money" align="center" label="预扣增值税和附加税">
					<template slot-scope="scope">
					{{ scope.row.added_tax_money }}
					</template>
					</el-table-column>
                    <el-table-column v-if="yichengdodinew_show" slot="second-column" prop="pay_fee" align="center" label="服务费">
                        <template slot-scope="scope">
                            {{ scope.row.pay_fee }}
                        </template>
                    </el-table-column>
                    <el-table-column v-if="yichengdodinew_show" slot="second-column" prop="balance_money" align="center" label="可用余额">
                        <template slot-scope="scope">
                            {{ scope.row.balance_money }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="alias_msg" align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button size="medium" @click="mxViewReceipt(scope.row.outer_trade_no, scope.row.yl_bank, scope.row.ele_receipt_url)" type="success" plain>
                                查看电子回单
                            </el-button>
                            <!-- v-if="scope.row.yl_bank !== 'alipay'" -->
                            <!-- <el-button size="medium" v-else disabled  type="info"
                         plain>支付宝暂不支持
              </el-button> -->
                        </template>
                    </el-table-column>
                </ApeTable>
            </div>
        </PageHeaderLayout>
        <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
            <template slot="content">
                <el-form :model="formData" :rules="dialogRules" ref="tradeWithdrawAttacmentForm" label-position="right" label-width="96px">
                    <el-form-item label="名称" prop="title"><el-input v-model="formData.title"></el-input></el-form-item>
                    <el-form-item label="附件" prop="attachment">
                        <ApeUploader
                            :limit="1"
                            :isImage="false"
                            :allowSize="1024 * 1024 * 500"
                            :allowTypeList="attachmentType"
                            @handleUploadSuccess="handleAttachmentUploadSuccess"
                            @handleUploadRemove="handleAttachmentUploadRemove"
                            :upload-file-list="attachmentUploadFileList"
                        ></ApeUploader>
                    </el-form-item>
                    <el-form-item label="备注" prop="intro"><el-input type="textarea" v-model="formData.intro"></el-input></el-form-item>
                </el-form>
            </template>
        </ModalDialog>
    </div>
</template>

<script>
  import {MessageBox} from 'element-ui'
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import ApeTable from '@/components/ApeTable';
import ApeDrawer from '@/components/ApeDrawer';
import ApeUploader from '@/components/ApeUploader';
import ModalDialog from '@/components/ModalDialog';
import DatePicker from '@/components/DatePicker.vue';
import ScreeCompany from '@/components/ScreeCompany.vue';
import MonthPicker from '@/components/MonthPicker.vue';
import { mapGetters } from 'vuex';

export default {
	components: {
		PageHeaderLayout,
		ApeDrawer,
		ApeTable,
		ApeUploader,
		ModalDialog,
		DatePicker,
		ScreeCompany,
		MonthPicker
	},
	data() {
		return {
			errCount:0,
			dianzi_downloadLoading:false,
			isLaowuCompany:false,
			is_other_remark: '',
            loadingScreen:null,
            exportList:[],
			current_export_page_size:0,
            export_page_size:500,
            export_current_page:1,
			is_yichen: false,
			yichengdodinew_show:false,
			// 允许显示的字段
			allowField: ['cardAttribute', 'sendStatus'],
			// element的cascader的props值
			cascaderProps: {
				label: 'display_name',
				value: 'id'
			},
			//导出表格类型
			bookType: 'xlsx',
			searchCategory: [],
			// 搜索条件
			downloadLoading: false,
			options: [
				{
					value: 'xlsx',
					label: 'xlsx'
				},
				{
					value: 'csv',
					label: 'csv'
				},
				{
					value: 'txt',
					label: 'txt'
				}
			],
			value: 'xlsx',
			searchCondition: {
				send_status: ''
			},
			search_time:'',
			loadingStaus: true,
			columns: [
				// {
				//   title: '订单号',
				//   value: 'outer_trade_no',
				//   header_align: 'center',
				//   align: 'center',
				// },
				// {
				//   title: '金额',
				//   value: 'money',
				//   width: 100,
				//   header_align: 'center',
				//   align: 'center',
				// },
				// {
				// title: '劳务费',
				// value: 'labor_dispatch_money',
				// /* width: 200, */
				// header_align: 'center',
				// align: 'center',
				// },
				{
					title: '附属信息',
					value: [
						// {label:'姓名：',value:'bank_account_name'},
						// {label:'订单号：',value:'outer_trade_no'},
						// {label:'子账号：',value:'uid'},
						// {label:'证件：',value:'id_number'},
						// {label:'类型：',value:'bank_code'},
						// {label:'账户：',value:'bank_account_no'},
						// {label:'备注：',value:'remark'},

						{ label: '证件：', value: 'id_number',isDesens:true },
						{ label: '账户：', value: 'bank_account_no',isDesens:true },
						{ label: '卡属性：', value: 'alias_card_attribute' },
						{ label: '备注：', value: 'remark' },
						{ label: '分行号：', value: 'bank_line_no' },
						{ label: '支行名称：', value: 'bank_branch' },
						{ label: '错误代码：', value: 'error_code' },
						{ label: '错误信息：', value: 'error_msg' },
						{ label: '银行渠道：', value: 'alias_pid' }
					],
					header_align: 'center',
					/*  align: 'center', */
					width: 300
				},
				// {
				//   title: '异步通知',
				//   value: 'notify_msg',
				//   header_align: 'center',
				//   align: 'center',
				//   width: 100
				// },
				// {
				//   title: '推送通知',
				//   value: [
				//     {label:'地址：',value:'push_url'},
				//     {label:'时间：',value:'push_time'},
				//   ],
				//   header_align: 'center',
				//   align: 'center',
				// },
				{
					title: '推送时间',
					header_align: 'center',
					align: 'center',
					value: 'push_time'
				},
				{
					title: '状态',
					width: 80,
					value: 'send_msg',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '创建时间',
					width: 150,
					value: 'created_at',
					// value: [
					//   {label:'创建时间：',value:'created_at'},
					//   {label:'更新时间：',value:'updated_at'},
					// ],
					header_align: 'center',
					align: 'center'
				}
			],
			// 表格列表数据
			tradeWithdrawList: [],
			// 分页信息
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			// 分页的offset,序号列使用
			offset: 0,
			// 已上传文件列表
			uploadFileList: [],
			// 表单验证
			rules: {
				title: [{ required: true, message: '输入标题', trigger: 'blur' }],
				type: [{ required: true, message: '选择类型', trigger: 'blur' }],
				is_new_win: [{ required: true, message: '选择打开发方式', trigger: 'blur' }],
				is_show: [{ required: true, message: '选择状态', trigger: 'blur' }],
				image: [{ required: true, message: '上传图片', trigger: 'blur', validator: this.apeUploaderVerify }]
			},
			// 抽屉数据，附件列表
			drawerData: {
				visible: false,
				loading: true,
				loading_text: '正在加载中……',
				// direction: 'right',
				title: '',
				width_height: '640px',
				show_footer: false
				// mask: false,
				// close_name: '关 闭',
				// confirm_name: '打 印',
			},
			// 附件列表
			attachmentList: [],
			// 附件列表字段定义
			attachmentColumns: [
				{
					title: '标题',
					value: 'title'
				}
			],
			// 添加附件
			dialogData: {
				visible: false,
				title: '',
				width: '24%',
				loading: true,
				modal: false
			},
			// 附件表单内容
			formData: {},
			// 附件添加表单验证
			dialogRules: {
				title: [{ required: true, message: '输入标题', trigger: 'blur' }]
			},
			// 附件类型
			attachmentType: ['application/pdf', 'application/caj', '', 'application/zip', 'application/rar', 'application/doc'],
			// 已上传附件列表
			attachmentUploadFileList: [],
			// 当前需要操作附件的文章id
			currentTradeWithdrawId: 0
		};
	},
	computed: {
		...mapGetters(['userPermissions', 'buttonType'])
	},
	watch: {
		'$route.matched': function(n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		}
	},
	methods: {
   async downFile  (pdfUrl,fileName)  {
        try {
        const res = await fetch(pdfUrl);
        if (!res.ok) {
			this.errCount+=1
			if(this.errCount===this.tradeWithdrawList.length){
			MessageBox.alert(`当前页面电子回单暂未生成`, '系统提示', {
			confirmButtonText: '确定',
			type: 'error',
			})
			}
        throw new Error(`Failed to fetch PDF: ${res.status} ${res.statusText}`);
        }
		console.log(res)
        const blob = await res.blob();
        const url = URL.createObjectURL(blob); // 传入用于创建 URL 的 File 对象、Blob,转换成浏览器可识别的blob格式
        console.log('url---',url); //blob:http://127.0.0.1:5500/f01dc675-8f01-4e47-9313-65b96321884f
        // 创建a标签，绑定href、download属性，添加在body，触发click事件
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName+'.pdf' || 'downloaded.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 移除元素
        URL.revokeObjectURL(url); // 当不再需要这些 URL 对象时,通过它释放掉
        } catch (error) {
        console.log(error)
        
        }
      
      },
   async dowloadDZHD(){
	//https://img.51xinlong.com/xladmin/e-receipt/KHL633995625745829888.pdf  正常
	//https://img.51xinlong.com/xladmin/e-receipt/KHL63399562574582988888888888.pdf  不正常
	this.dianzi_downloadLoading=true
	let urls=[]
	this.tradeWithdrawList.map(item=>{
		let url=''
		if(item.ele_receipt_url){
		url = item.ele_receipt_url
		}else{
		url = `${this.$config.ossDomain}/${this.$config.ossAppDir}/e-receipt/${item.outer_trade_no}.pdf`
		}
		urls.push(url)
	})
	try{
		let result = await this.$api.postExportReceipt({urls});
		if(result){
			window.open(result,'_blank')
		}
	}catch(e){
		//TODO handle the exception
		console.log(e)
	}finally{
		this.dianzi_downloadLoading=false
	}
		
      
    },
		async isImport() {
			let args = {
				companyId: this.$route.params.company_id
			};
			let result = await this.$api.isImport(args);
			if (result) {
				this.is_other_remark = result.is_other_remark; //是否是九尾公司
				console.log('this.is_other_remark1', this.is_other_remark);
				if (this.is_other_remark == 1) {
					let columns = this.columns;
					columns.splice(0, 0, {
						title: '项目',
						width: 150,
						value: 'other_remark',
						header_align: 'center',
						align: 'center'
					});
					this.columns = columns;
				}
			}
		},
		// 导出日期
		MonthSearch(v) {
			console.log(v);
			if (v) {
				this.searchCondition.time_value = v;
				this.$refs.dataSearch.value=[]
				this.search_time=''
				//console.log(this.$refs.dataSearch.value)
			}
			this.init('search');
		},
		ScreeCompany(v, name) {
			if (name == 'cardAttribute') {
				if (v) {
					this.searchCondition.card_attribute = v;
				} else {
					delete this.searchCondition.card_attribute;
				}
				this.init('search');
			}

			if (name == 'sendStatus') {
				if (v) {
					this.searchCondition.send_status = v;
				} else {
					delete this.searchCondition.send_status;
				}
				this.init('search');
			}
		},
		// 搜索
		searchButton() {
			if(this.$refs.MonthSearch){
				this.$refs.MonthSearch.dataValue=''
			}
			if(!this.search_time){
				this.searchCondition.time_value=''
			}
			this.init('search');
		},
		selectData(e) {
			this.bookType = e;
		},
        openFullScreen() {
         this.loadingScreen = this.$loading({
            lock: true,
            text: '正在导出...',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
            });
        },
        async handleBeforeDownload(){
			if(this.pagingData.total<=0){
				this.$message.warning('暂无可导出数据')
				return
			}
			this.exportList=[]
            if(this.isExport){
                return;
            }
            this.openFullScreen();
            this.isExport = true;
            this.export_current_page = 1;
            this.downloadLoading = true;
            try{
            this.getexportData()
            }catch(e){
            this.downloadLoading = false;
            this.isExport=false;
            this.$message.error('数据量太大，请联系客服'+e)
            }
        },
		// async getexportData(){
        //     if(Math.ceil(this.pagingData.total/this.export_page_size)>=this.export_current_page){
        //         let list_export = await this.init('export',this.export_current_page)
        //         this.exportList=list_export
		// 		this.handleDownload(this.exportList,this.export_current_page)
		// 		this.export_current_page+=1;
		// 		setTimeout(()=>{
		// 			this.getexportData()
		// 		},3000)
		// 		let num = (this.export_current_page * this.export_page_size) - this.export_page_size
		// 		console.log(num,this.pagingData.total,'xxxx');
		// 		let result = (num/this.pagingData.total).toFixed(2)*100
		// 		this.loadingScreen.text = `进度${result}%`
		// 		if(num >= this.pagingData.total){
		// 			this.loadingScreen.close();
		// 		}
		// 	}
        // },
		GetPercent(num, total) {
			/// <summary>
			/// 求百分比
			/// </summary>
			/// <param name="num">当前数</param>
			/// <param name="total">总数</param>
			num = parseFloat(num);
			total = parseFloat(total);
			if (isNaN(num) || isNaN(total)) {
			return "-";
			}
			return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00)+"%";
		},
		async getexportData(){
			if(this.pagingData.total>100000){
			this.downloadLoading = false;
			this.isExport=false;
			this.$message.warning('单次导出最高10万条数据,超出请分批导出或联系客服')
			this.loadingScreen.close();
			return
			}
            if(this.pagingData.total>=this.export_page_size){
                let list_export = await this.init('export',this.export_current_page)
                this.exportList = this.exportList.concat(list_export)
				this.current_export_page_size = this.export_page_size * this.export_current_page
				this.export_current_page+=1;
				//let result = this.GetPercent(this.current_export_page_size,this.pagingData.total)
				this.loadingScreen.text = `请勿离开当前页面,进度${this.current_export_page_size}/${this.pagingData.total}`
				let ratioValue = this.current_export_page_size / 20000
				// console.log(ratioValue,Number.isInteger(ratioValue),'当前进度');
				if(this.current_export_page_size >= this.pagingData.total){
					try{
					this.handleDownload(this.exportList,ratioValue)
					}catch(e){
					this.downloadLoading = false;
					this.isExport=false;
					this.loadingScreen.close();
					this.$message.error('数据量太大，请联系客服'+e)
					return
					}
					return
				}
				
				setTimeout(()=>{
					this.getexportData()
				})
			}else{
				let list_export = await this.init('export',this.export_current_page)
				this.handleDownload(list_export,this.export_current_page)
				this.loadingScreen.close();
			}
        },
		//导出
		async handleDownload(list,index) {
			import('@/excel/Export2Excel').then(excel => {

				let tHeader = [];
				if(this.isLaowuCompany){
					tHeader = ['ID','公司名称', '订单号', '姓名', '身份证号','账户','结算金额', '实收金额', '卡属性: （C 对私，B 对公）', '备注', '状态', '错误代码', '错误信息', '下发时间','增值税','附加税','个税'];
				}
				// else if (this.is_other_remark == 1) {
				// 	tHeader = ['公司名称', '订单号', '姓名', '身份证号','账户', '实发金额', '卡属性: （C 对私，B 对公）', '备注', '项目', '状态', '错误代码', '错误信息', '下发时间'];
				// }
				else if(this.yichengdodinew_show){
					tHeader = ['ID','公司名称', '订单号', '姓名', '身份证号','账户','实发金额','服务费','可用余额', '卡属性: （C 对私，B 对公）', '备注', '状态', '错误代码', '错误信息', '下发时间'];
				}else {
					tHeader = ['ID','公司名称', '订单号', '姓名', '身份证号','账户','金额', '实发金额','个税', '卡属性: （C 对私，B 对公）', '备注', '状态', '错误代码', '错误信息', '下发时间'];	
				}
				const data = this.formatJson(list);
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `发放列表(${index})${time}`;
				excel.export_json_to_excel({
					header: tHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.bookType //Optional
				});
				this.downloadLoading = false;
				this.isExport=false;
				this.loadingScreen.close();
			});
		},
		formatJson(jsonData) {
			return jsonData.map(v => {

				let { id,company_name, outer_trade_no, bank_account_name, id_number,bank_account_no, money,real_money,now_tax_money, card_attribute, remark, send_msg, error_code, error_msg, created_at,after_tax_money,value_added_tax,additional_tax,personal_income_tax } = v;
				if(this.isLaowuCompany){
					return [id.toString(),company_name, outer_trade_no, bank_account_name, id_number,bank_account_no,money, after_tax_money, card_attribute, remark, send_msg, error_code, error_msg, created_at,value_added_tax,additional_tax,personal_income_tax]
				}
				// else if (this.is_other_remark == 1) {
				// 	return [company_name, outer_trade_no, bank_account_name, id_number,bank_account_no, money, card_attribute, remark, other_remark, send_msg, error_code, error_msg, created_at];
				// } 
				else if(this.yichengdodinew_show){
					let { id,company_name, outer_trade_no, bank_account_name, id_number,bank_account_no, money,pay_fee,balance_money, card_attribute, remark, send_msg, error_code, error_msg, created_at } = v;
					return [id.toString(),company_name, outer_trade_no, bank_account_name, id_number,bank_account_no, money,pay_fee,balance_money, card_attribute, remark, send_msg, error_code, error_msg, created_at];
				}else {
					return [id.toString(),company_name, outer_trade_no, bank_account_name, id_number,bank_account_no, money,real_money,now_tax_money, card_attribute, remark, send_msg, error_code, error_msg, created_at];
				}

			});
		},
		// 切换页码操作
		async switchPaging() {
			this.init();
		},
		// 响应添加按钮
		async addButton() {
			this.$router.push(this.$route.path + '/create');
		},
		// 响应详情按钮
		async viewButton(id) {
			this.$router.push(this.$route.path + '/' + id + '/view');
		},
		// 响应编辑按钮
		async editButton(id) {
			this.$router.push(this.$route.path + '/' + id + '/edit');
		},
		// 相应删除按钮
		async deleteButton(id) {
			let info = await this.$api.deleteMixinWithdraw(id);
			if (info == 'ok') {
				this.$nextTick(() => {
					this.init('del');
				});
			} else {
				this.$message.error(info);
			}
		},

		// 文章添加附件
		tradeWithdrawAttachment(row) {
			this.currentTradeWithdrawId = row.id;
			this.drawerData.loading_text = '正在加载中……';
			this.drawerData.visible = true;
			this.drawerData.title = '附件列表（' + row.title + '）';
			this.initTradeWithdrawAttachmentList();
			this.$nextTick(() => {
				this.drawerData.loading = false;
			});
		},
		// 处理抽屉关闭
		drawerClose() {
			this.drawerData.visible = false;
			this.drawerData.loading = true;
		},
		//获取选中日期的值
		dataSearch(value) {
			console.log(value)
			this.search_time=value
			//console.log(this.$refs.MonthSearch)
			this.searchCondition.time_value = value;
		},
		// 初始化文章列表
		async init(type,exportCurrentPage=1) {
			if (type) {
				this.mxResetPage();
			}
			let pagingInfo = this.$refs['apeTable'].getPagingInfo(type);
			if (type == 'export') {
				pagingInfo.page_size = this.export_page_size;
                pagingInfo.current_page = exportCurrentPage;
			} else {
				this.loadingStaus = true;
			}
			let searchCondition = this.handleSearchCondition();
			Object.assign(searchCondition, pagingInfo);
			let { list, pages } = await this.$api.getMxWithdrawList(searchCondition);
			if (type == 'export') {
				return list;
			} else {
				this.tradeWithdrawList = [];
				this.$nextTick(() => {
					this.tradeWithdrawList = list;
					this.tradeWithdrawList.forEach(item => {
						switch (item.pid) {
							case 'ws':
								item.pid = '网商银行';
								break;
							case 'yinglin':
								item.pid = '银灵科技';
								break;
							default:
								break;
						}
					});
				});
				this.pagingData.total = pages.total;
				this.offset = pages.offset;
				this.loadingStaus = false;
			}
		},
		// 处理搜索条件
		handleSearchCondition() {
			let condition = {};
			if (this.searchCondition.outer_trade_no) {
				condition.outer_trade_no = this.searchCondition.outer_trade_no;
			}
			if (this.searchCondition.name) {
				condition.name = this.searchCondition.name;
			}
			if (this.searchCondition.time_value) {
				condition.time = {
					start_time: this.searchCondition.time_value[0],
					end_time: this.searchCondition.time_value[1]
				};
			}
			if (this.searchCondition.bank_account_name) {
				condition.bank_account_name = this.searchCondition.bank_account_name;
			}
			if (this.searchCondition.id_number) {
				condition.id_number = this.searchCondition.id_number;
			}
			if (this.searchCondition.card_attribute) {
				condition.card_attribute = this.searchCondition.card_attribute;
			}
			if (this.searchCondition.send_status) {
				condition.send_status = this.searchCondition.send_status;
			}
			return condition;
		},
		// 获取文章分类列表
		async getCategoryList() {
			// 获取文章分类列表
			let { list } = await this.$api.getMixinWithdrawCategoryList();
			this.searchCategory = list;
		},
		// 初始化文件附件列表
		async initTradeWithdrawAttachmentList() {
			let list = await this.$api.getMixinWithdrawAttachment(this.currentTradeWithdrawId);
			this.attachmentList = list;
		},
		// 附件上传成功回调
		handleAttachmentUploadSuccess(file, fileList) {
			this.formData.attachment_id = file.id;
			this.attachmentUploadFileList = fileList;
		},
		// 附件删除回调
		handleAttachmentUploadRemove(file, fileList) {
			this.formData.attachment_id = 0;
			this.attachmentUploadFileList = fileList;
		},
		// form数据提交，请求接口,文章附件
		async formSubmit() {
			this.dialogData.loading_text = '正在提交中……';
			this.dialogData.loading = true;
			this.formData.tradeWithdraw_id = this.currentTradeWithdrawId;
			let id = await this.$api.saveMixinWithdrawAttachment(this.formData);
			this.$nextTick(() => {
				this.dialogClose();
			});
			this.$nextTick(() => {
				if (id) {
					this.initTradeWithdrawAttachmentList();
				}
			});
			this.$nextTick(() => {
				this.$message.success('保存成功!');
			});
		},
		// 处理模态框，确定事件
		handleConfirm() {
			// 调用组件的数据验证方法
			this.$refs['tradeWithdrawAttacmentForm'].validate(valid => {
				if (valid) {
					this.formSubmit();
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！');
				}
			});
		},
		// 处理模态框，关闭事件
		dialogClose() {
			this.dialogData.visible = false;
			this.dialogData.loading = true;
			this.formData = {};
			this.attachmentUploadFileList = [];
		},
		// 响应添加附件按钮
		async addAttachment() {
			this.dialogData.visible = true;
			this.dialogData.loading = false;
			this.dialogData.title = '添加附件';
		},
		// 相应删除文章附件按钮
		async deleteTradeWithdrawAttachmentButton(id) {
			let info = await this.$api.deleteMixinWithdrawAttachment(id);
			if (info == 'ok') {
				this.$nextTick(() => {
					this.initTradeWithdrawAttachmentList();
				});
			} else {
				this.$message.error(info);
			}
		},
		keyupSubmit() {
			document.onkeydown = e => {
				console.log(e);
				let _key = window.event.keyCode;
				if (_key === 13) {
					this.searchButton();
				}
			};
		},
		// 是否是劳务公司
		async getIsLaoWu(){
			let settlementList = await this.$api.getUserSettlement({
				company_id:JSON.parse(localStorage.getItem('nowCompany')).id
			})
			// console.log(settlementList)
			let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
			let newSettlementList = Object.assign(settlementList, [])
			
			newSettlementList.map(item=>{
				if(item.id == companyIds){
				if(item.is_labor_dispatch != 0){
					this.isLaowuCompany = true
				}
				}
			})
			
			console.log(this.isLaowuCompany,'返回标识')
			if(this.isLaowuCompany){
				this.columns = [
					{
					title: '增值税',
					value: 'value_added_tax',
					/* width: 200, */
					header_align: 'center',
					align: 'center',
					},
					{
					title: '附加税',
					value: 'additional_tax',
					/* width: 200, */
					header_align: 'center',
					align: 'center',
					},
					{
					title: '个税',
					value: 'personal_income_tax',
					/* width: 200, */
					header_align: 'center',
					align: 'center',
					},
					{
						title:'结算金额',
						header_align:'center',
						align: 'center',
						value:'money'	
					},
					{
						title: '附属信息',
						value: [
							// {label:'姓名：',value:'bank_account_name'},
							// {label:'订单号：',value:'outer_trade_no'},
							// {label:'子账号：',value:'uid'},
							// {label:'证件：',value:'id_number'},
							// {label:'类型：',value:'bank_code'},
							// {label:'账户：',value:'bank_account_no'},
							// {label:'备注：',value:'remark'},

							{ label: '证件：', value: 'id_number',isDesens:true },
							{ label: '账户：', value: 'bank_account_no',isDesens:true },
							{ label: '卡属性：', value: 'alias_card_attribute' },
							{ label: '备注：', value: 'remark' },
							{ label: '分行号：', value: 'bank_line_no' },
							{ label: '支行名称：', value: 'bank_branch' },
							{ label: '错误代码：', value: 'error_code' },
							{ label: '错误信息：', value: 'error_msg' },
							{ label: '银行渠道：', value: 'alias_pid' }
						],
						header_align: 'center',
						/*  align: 'center', */
						width: 300
					},
					{
						title: '推送时间',
						header_align: 'center',
						align: 'center',
						value: 'push_time'
					},
					{
						title: '状态',
						width: 80,
						value: 'send_msg',
						header_align: 'center',
						align: 'center'
					},
					{
						title: '创建时间',
						width: 150,
						value: 'created_at',
						// value: [
						//   {label:'创建时间：',value:'created_at'},
						//   {label:'更新时间：',value:'updated_at'},
						// ],
						header_align: 'center',
						align: 'center'
					}
				]

			}
		},
	},
	created() {
		this.is_yichen = !this.$storage.get('is_yichen');
		this.yichengdodinew_show=this.$storage.get('roles')?.includes('yichendaodinew')
		console.log(this.$storage.get('roles'))
		console.log(this.yichengdodinew_show)
		this.keyupSubmit();
		this.getIsLaoWu()
	},
	mounted() {
		// this.isImport();
		this.init();
	}
};
</script>

<style lang="stylus" scoped>
.el-button
    margin-right 4px
    margin-bottom 4px
.table-header
    margin-bottom 12px
.el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
.el-table
    font-size 14px
.table-right
    float right
.select-box
    width 100px
.second-row
    margin-top -20px
</style>
